/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateApplicationDraft200ResponseData
 */
export interface CreateApplicationDraft200ResponseData {
  /**
   * Относительная ссылка на редактор заявки
   * @type {string}
   * @memberof CreateApplicationDraft200ResponseData
   */
  link: string
}

/**
 * Check if a given object implements the CreateApplicationDraft200ResponseData interface.
 */
export function instanceOfCreateApplicationDraft200ResponseData(
  value: object
): value is CreateApplicationDraft200ResponseData {
  if (!('link' in value) || value['link'] === undefined) return false
  return true
}

export function CreateApplicationDraft200ResponseDataFromJSON(
  json: any
): CreateApplicationDraft200ResponseData {
  return CreateApplicationDraft200ResponseDataFromJSONTyped(json, false)
}

export function CreateApplicationDraft200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateApplicationDraft200ResponseData {
  if (json == null) {
    return json
  }
  return {
    link: json['link'],
  }
}

export function CreateApplicationDraft200ResponseDataToJSON(
  value?: CreateApplicationDraft200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    link: value['link'],
  }
}
